const resetwizard = {
    step:1,
    lastStepCompleted:1,
    savingComponentState:false,
    componentStateSaved:false,
  };

  const resetpayment = {
    nameoncard:'',
    ccnumber:'',
    expiration:'',
    cvc:'', 
    depositamount:null,
  };

export default {
    eventId:0,
    inWizardMode:false,
    eventRetrieved:false,
    memberRetrieved:false,
    currentWizardStep:1,  
    lastStepCompleted:1,
    //fetchingevent:false,
    ...resetwizard,	
    ...resetpayment			
}


// WEBPACK FOOTER //
// ./src/utils/constants/resetposteventfields.js